/**
 * Created by matheusmorett on 26/03/18.
 */
import React, { Component } from 'react';
import {Helmet} from "react-helmet";
import {observer, inject} from 'mobx-react';
import {Link} from 'react-router-dom';
import "./../assets/About.scss";

import Text from "components/Text";
import SideMenu from "components/SideMenu/SideMenuFaq";

@inject("ApplicationStore")
@observer
class Doubts extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: false,
        };

        const { ApplicationStore } = this.props;
        ApplicationStore.setMenuBackgroundWhite();
        ApplicationStore.setPageBackground("#f2f2f2");
    }

    componentWillUnmount() {
        const { ApplicationStore } = this.props;
        ApplicationStore.unsetPageBackground();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        const link = () => <span className="link"><Link to='https://goo.gl/4HwGY2'>link</Link></span>;
        return (
            <div className="About">
                <Helmet>
                    <title> Adrena.me - Sobre</title>
                </Helmet>
                <div className="wrapper">
                    <div className="about-container">
                        <SideMenu
                            items={[
                                {
                                    name: "Sobre",
                                    active: true,
                                    link: "/sobre",
                                    icon: "fa-info"
                                },
                                {
                                    name: "Política de privacidade",
                                    active: false,
                                    link: "/seguranca",
                                    icon: "fa-lock"
                                },
                                {
                                    name: "Regra de Cancelamento",
                                    active: false,
                                    link: "/cancelamento",
                                    icon: "fa-window-close"
                                },
                                {
                                    name: "Termo de Uso",
                                    active: false,
                                    link: "/termo-de-uso",
                                    icon: "fa-sticky-note"
                                },
                                {
                                    name: "FAQ",
                                    active: false,
                                    link: "/faq",
                                    icon: "fa-question-circle"
                                },
                                {
                                    name: "Contato",
                                    active: false,
                                    link: "/contato",
                                    icon: "fa-phone"
                                },
                            ]}
                        />
                        <Text
                            title="Sobre o Adrena"
                            items={[
                                {
                                    title: "Sobre",
                                    text: "O Adrena é uma empresa fundada por apaixonados em aventuras, esportes radicais e contato com a natureza. Nós acreditamos que as pessoas precisam se aventurar, precisam buscar formas de sair da rotina para manter corpo e mente saudáveis. Foco no futuro e na experiência do usuário, é assim que nossa equipe trabalha para oferecer o melhor serviço de agendamento online e portal de informações do mercado de aventuras.",
                                },
                                {
                                    title: "Por que o Adrena.me surgiu?",
                                    text: "O Adrena surgiu porque nós acreditamos que toda pessoa é aventureira em sua essência, mas nem todo mundo descobriu aquilo que desperta esse espírito. Por isso nós consolidamos tudo aquilo que imaginamos motivar você a sair da rotina e te trazer para o nosso mundo de aventuras. Além disso, quem tem a ideia ou a motivação de fazer atividades como: Escape Game, Arquearia, Balonismo, Paraquedismo, Airsoft? Geralmente ficamos na mesmice e acabamos por entrar na zona de conforto, deixando de realizar o que a vida tem de melhor a oferecer. Nosso portal de informações busca justamente quebrar esse paradigma e dar maior poder de decisão aos usuários, oferecendo todas as aventuras e esportes radicais disponíveis na sua região."
                                },
                                {
                                    title: "O que nós fazemos?",
                                    text: "Nós somos um serviço digital que conecta aventureiros+aventuras, buscamos empresas que oferecem experiências adrenalizadas, ecoturismo e esportes radicais e oferecemos um espaço em nosso site para que a informação chegue até você de forma clara e precisa. Além disso, o Adrena permite com que todo o agendamento seja feito de forma online, sem precisar ficar ligando para o estabelecimento para consultar as datas disponíveis e tirar dúvidas, pois aqui você tem uma visão geral de toda a agenda da empresa, ficando muito mais fácil de decidir com a galera o melhor dia ou atividade a fazer."
                                },
                                {
                                    title: "Por que agendar conosco?",
                                    text: "Porque aqui todas as aventuras e esportes radicais são cuidadosamente inseridas na plataforma, garantindo que as informações ali contidas sejam fidedignas às atividades oferecidas pelas empresas parceiras. Além disso, o processo é rápido e fácil, possibilitando o compartilhamento de links de pagamento entre você e seus amigos, agilizando a organização de equipes."
                                },
                                {
                                    title: "Como faço para oferecer meus serviços na plataforma?",
                                    text: ["Acesse a página ", <span className='link' onClick={() => window.open("https://goo.gl/4HwGY2", '_blank')}>Parceiros</span>, ", preencha o formulário e enviaremos o acesso ao App para voc começar a cadastrar suas aventuras!"]
                                }
                            ]}
                        />


                    </div>
                </div>
            </div>
        )
    }

}
export default Doubts;